/* eslint-disable react-refresh/only-export-components */
import { lazy } from "react";
import type { RouteObject } from "react-router-dom";

const HaccpListTechnicalSheets = lazy(
  () => import("@/pages/haccp/technicalsheets/HaccpTechnicalSheets"),
);
const HaccpTechnicalSheetsLayout = lazy(
  () => import("@/pages/haccp/technicalsheets/HaccpTechnicalSheetsLayout"),
);
const HaccpListTechnicalSheetView = lazy(
  () =>
    import(
      "@/pages/haccp/technicalsheets/components/list/HaccpListTechnicalSheetView"
    ),
);
const HaccpDetailTechnicalSheetView = lazy(
  () =>
    import(
      "@/pages/haccp/technicalsheets/components/detail/HaccpDetailTechnicalSheetView"
    ),
);

export const technicalsheetsRoutes: RouteObject[] = [
  {
    path: "/haccp/technicalsheets",
    element: <HaccpListTechnicalSheets />,
    children: [
      {
        path: "domain/:domainId/site/:siteId",
        element: <HaccpTechnicalSheetsLayout />,
        children: [
          {
            path: "",
            element: <HaccpListTechnicalSheetView />,
          },
          {
            path: "technicalsheet/:technicalSheetId",
            element: <HaccpDetailTechnicalSheetView />,
          },
        ],
      },
    ],
  },
];
